import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'
import { getHomeData } from '@/lib/api'

const DUMMY = {
  heroTitle: 'ALRIFAI',
  heroSubtitle: 'TOGETHER, WE ALL WIN',
  heroDesc: 'Join Ghassan Al Rifai On His Inspiring Journey And Learn How His Unique Approach To Leadership And Belief In Collective Achievement Have Shaped A New Era Of Business Success.',
  heroImage: '/ghassan-real.jpg',
  ghassanDesc: 'Ghassan Alrifai, A Visionary Entrepreneur, Has Pioneered Innovative Solutions And Driven Sustainable Growth Through His Expertise In Technology, Sales, And Strategic Planning',
  storyText: "Ghassan Al-Rifai's Journey Highlights His Relentless Drive And Innovation. With Expertise In Business Development, Technology, And Strategic Planning, He Is Committed To Collaboration And Spotting Opportunities, Fueling His Mission To Empower Future Innovators.",
  businesses: [
    { id: 1, title: 'Veteran General Contracting', image: '/placeholder-logo.png' },
    { id: 2, title: 'Treasure Deal Invest', image: '/placeholder-logo.png' },
    { id: 3, title: 'Treasure Deal Group', image: '/placeholder-logo.png' },
  ],
  visionDesc: "Ghassan Al Rifai's Vision Is All About Empowering Entrepreneurs And Creating A Lively Environment Of Innovation And Growth. He Believes In The Power Of Collaboration And Mutual Success, Aiming To Build Win-Win Partnerships And Foster Relationships That Drive Collective Growth.",
  missionDesc: "Ghassan Alrifai's Mission Is Clear, He Supports Aspiring Entrepreneurs From His Extensive Experience Across Diverse Industries. He Also Invests In Promising Startups And Disruptive Technologies, Providing Essential Capital And Expertise To Fuel Their Success And Contribute To A Thriving Future.",
  missionCards: [
    { id: 1, title: 'Investment and Support', desc: 'Invest Venture capital and disruptive technologies with critical capital and expertise to fuel their success and contribute to a thriving future.' },
    { id: 2, title: 'Mentorship and Guidance', desc: 'Invest Venture capital and strategic guidance to emerging entrepreneurs, utilizing extensive experience across various industries.' },
    { id: 3, title: 'Legacy of Impact', desc: 'Invest Venture capital and strategic guidance to emerging entrepreneurs, utilizing extensive experience across various industries.' },
  ],
  coreValuesDesc: "Ghassan Alrifai's Core Values Are At The Heart Are Collaboration, Innovation, Growth, And Impact. He Believes In The Power Of Partnership And Shared Success, He Is Committed To Embracing New Ideas And Pioneering Cutting-Edge Solutions, Dedicated To Nurturing Both Individual And Collective Development, And Strive To Make A Meaningful Difference In The Entrepreneurial Landscape.",
  coreValues: [
    { id: 1, title: 'COLLABORATION', desc: 'Harnessing The Power Of Partnerships To Accomplish Mutual Business.' },
    { id: 2, title: 'INNOVATION', desc: 'Committed To Advancing New Ideas And Cutting-Edge Solutions.' },
    { id: 3, title: 'GROWTH', desc: 'Focusing On Nurturing Both Individual And Shared Development.' },
  ],
  blogs: [
    { id: '1', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-homs.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
    { id: '2', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-steve-jobs.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
    { id: '3', title: 'Fly High With Our Exclusive Travel Tips', image: '/investment-wealth.jpg', date: '24/08/2024', category: 'Business', likes: 23, comments: 5 },
  ],
}

const ICON_MISSION = [
  <svg key="1" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>,
  <svg key="2" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>,
  <svg key="3" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
]
const ICON_VALUES = [
  <svg key="1" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  <svg key="2" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>,
  <svg key="3" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>,
]

export default async function Home() {
  let api: any = null
  try { api = await getHomeData() } catch {}

  const slider = api?.sliders?.[0]
  const heroImage = slider?.image || DUMMY.heroImage
  const heroSubtitle = slider?.title || DUMMY.heroSubtitle
  const heroDesc = slider?.description || DUMMY.heroDesc
  const ghassanDesc = api?.about?.description || DUMMY.ghassanDesc
  const visionDesc = api?.vision?.description || DUMMY.visionDesc

  const rawBlogs = api?.latest_blogs?.slice(0, 3) || []
  const blogs = rawBlogs.length > 0
    ? rawBlogs.map((p: any) => ({ id: String(p.id), title: p.title, image: p.image, date: p.created_at, category: '', likes: p.likes_count ?? 0, comments: p.comments_count ?? 0 }))
    : DUMMY.blogs

  const rawBiz = api?.businesses?.slice(0, 3) || []
  const businesses = rawBiz.length > 0 ? rawBiz : DUMMY.businesses

  const rawMission = api?.mission?.slice(0, 3) || []
  const missionCards = rawMission.length > 0
    ? rawMission.map((c: any) => ({ id: c.id, title: c.title, desc: c.contents?.[0]?.content || '' }))
    : DUMMY.missionCards

  const rawValues = api?.core_values?.slice(0, 3) || []
  const coreValues = rawValues.length > 0
    ? rawValues.map((v: any) => ({ id: v.id, title: v.title?.toUpperCase(), desc: v.description || v.quotes }))
    : DUMMY.coreValues

  return (
    <>
      {/* ── Responsive CSS ── */}
      <style>{`
        .hero-text { padding-left: 56px; padding-right: 56px; }
        .hero-photo { width: 55%; }
        .hero-h1 { font-size: 60px; }
        .hero-sub { font-size: 19px; }
        .hero-ch { font-size: 360px; left: 34%; }
        .section-inner { max-width: 1100px; margin: 0 auto; padding: 0 56px; }
        .section-inner-sm { max-width: 680px; margin: 0 auto; padding: 0 40px; }
        .ghassan-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 60px; align-items: center; }
        .ghassan-photo { display: flex; justify-content: flex-start; }
        .ghassan-photo-wrap { position: relative; width: 310px; height: 350px; }
        .story-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; }
        .biz-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; max-width: 860px; margin: 0 auto; }
        .mission-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 22px; }
        .values-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; max-width: 900px; margin: 0 auto; }
        .blog-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; }

        @media (max-width: 1024px) {
          .section-inner { padding: 0 32px; }
          .biz-grid { max-width: 100%; }
          .values-grid { max-width: 100%; }
        }

        @media (max-width: 768px) {
          .hero-text { padding-left: 24px; padding-right: 24px; }
          .hero-photo { width: 100%; opacity: 0.3; }
          .hero-h1 { font-size: 42px; }
          .hero-sub { font-size: 16px; }
          .hero-ch { font-size: 180px; left: 20%; top: 10%; transform: none; }
          .section-inner { padding: 0 20px; }
          .section-inner-sm { padding: 0 20px; }
          .ghassan-grid { grid-template-columns: 1fr; gap: 32px; }
          .ghassan-photo { justify-content: center; }
          .ghassan-photo-wrap { width: 240px; height: 270px; }
          .story-grid { grid-template-columns: 1fr; gap: 16px; }
          .biz-grid { grid-template-columns: 1fr; gap: 14px; max-width: 340px; }
          .mission-grid { grid-template-columns: 1fr; gap: 16px; }
          .values-grid { grid-template-columns: 1fr; gap: 16px; }
          .blog-grid { grid-template-columns: 1fr; gap: 16px; }
        }

        @media (min-width: 480px) and (max-width: 768px) {
          .biz-grid { grid-template-columns: 1fr 1fr; max-width: 480px; }
          .mission-grid { grid-template-columns: 1fr 1fr; }
          .values-grid { grid-template-columns: 1fr 1fr; }
          .blog-grid { grid-template-columns: 1fr 1fr; }
        }

        @media (max-width: 480px) {
          .hero-h1 { font-size: 36px; }
          .hero-sub { font-size: 14px; }
        }
      `}</style>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ S1 — HERO ━━━ */}
      <section className="relative w-full overflow-hidden flex items-center" style={{ height: 'calc(100vh - 72px)', minHeight: '500px', background: '#000' }}>
        <div className="hero-photo absolute right-0 top-0 bottom-0">
          <img src={heroImage} alt="Ghassan" className="w-full h-full object-cover object-center" />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg,#000 0%,rgba(0,0,0,0.88)16%,rgba(0,0,0,0.45)42%,rgba(0,0,0,0.05)72%,transparent 100%)' }} />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(270deg,#000 0%,rgba(0,0,0,0.60)8%,transparent 28%)' }} />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg,rgba(0,0,0,0.50)0%,transparent 20%)' }} />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(0deg,rgba(0,0,0,0.50)0%,transparent 20%)' }} />
        </div>

        <div className="hero-ch absolute pointer-events-none select-none" style={{ top:'50%',transform:'translateY(-52%)',fontWeight:900,lineHeight:1,color:'transparent',WebkitTextStroke:'1.5px rgba(255,255,255,0.07)',whiteSpace:'nowrap',zIndex:2 }}>Ch</div>

        <div className="absolute z-20 flex items-center justify-center rounded-full" style={{ bottom:'24px',right:'24px',width:'50px',height:'50px',background:'#f97316',boxShadow:'0 4px 20px rgba(249,115,22,0.5)' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        </div>

        <div className="hero-text relative z-10 w-full">
          <div style={{ maxWidth: '480px' }}>
            <h1 className="hero-h1" style={{ fontWeight:900,lineHeight:1.0,letterSpacing:'0.01em',color:'rgba(188,204,228,0.95)',marginBottom:'4px' }}>{DUMMY.heroTitle}</h1>
            <p className="hero-sub" style={{ fontWeight:800,color:'#f97316',letterSpacing:'0.04em',marginBottom:'20px' }}>{heroSubtitle}</p>
            <p style={{ fontSize:'14px',lineHeight:1.85,color:'rgba(255,255,255,0.76)',maxWidth:'420px',marginBottom:'36px' }}>{heroDesc}</p>
            <div style={{ display:'flex',alignItems:'center',gap:'6px' }}>
              <div style={{ width:'32px',height:'4px',borderRadius:'2px',background:'#f97316' }} />
              {[0,1,2].map(i => <div key={i} style={{ width:'6px',height:'6px',borderRadius:'50%',background:'rgba(255,255,255,0.25)' }} />)}
            </div>
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ S2 — GHASSAN ━━━ */}
      <section className="relative overflow-hidden" style={{ background:'#23262f',minHeight:'480px',padding:'72px 0' }}>
        <div className="absolute inset-0" style={{ backgroundImage:'url(/arab-pattern-bg.jpg)',backgroundSize:'cover',backgroundPosition:'center',opacity:0.18,zIndex:0 }} />
        <div className="section-inner relative z-10">
          <div className="ghassan-grid">
            <div className="ghassan-photo">
              <div className="ghassan-photo-wrap">
                <div style={{ position:'absolute',inset:'-4px',background:'conic-gradient(from 0deg,#fff 0deg,#4ade80 40deg,#818cf8 90deg,#f472b6 140deg,#fb923c 180deg,#fff 220deg,#22d3ee 270deg,#a3e635 320deg,#fff 360deg)',clipPath:'polygon(50% 0%,58% 3%,65% 0%,72% 5%,80% 2%,86% 8%,93% 6%,98% 12%,100% 20%,97% 28%,100% 36%,98% 44%,100% 52%,97% 60%,99% 68%,95% 75%,98% 82%,93% 88%,88% 93%,80% 97%,73% 100%,65% 97%,57% 100%,49% 97%,41% 100%,33% 97%,25% 100%,17% 96%,10% 92%,5% 85%,2% 77%,0% 68%,3% 60%,0% 52%,2% 44%,0% 36%,3% 28%,0% 20%,4% 12%,9% 6%,16% 2%,23% 5%,30% 1%,38% 4%)',zIndex:0 }} />
                <div style={{ position:'absolute',inset:'2px',background:'#fff',clipPath:'polygon(50% 0%,58% 3%,65% 0%,72% 5%,80% 2%,86% 8%,93% 6%,98% 12%,100% 20%,97% 28%,100% 36%,98% 44%,100% 52%,97% 60%,99% 68%,95% 75%,98% 82%,93% 88%,88% 93%,80% 97%,73% 100%,65% 97%,57% 100%,49% 97%,41% 100%,33% 97%,25% 100%,17% 96%,10% 92%,5% 85%,2% 77%,0% 68%,3% 60%,0% 52%,2% 44%,0% 36%,3% 28%,0% 20%,4% 12%,9% 6%,16% 2%,23% 5%,30% 1%,38% 4%)',zIndex:1 }} />
                <img src="/ghassan-artistic.jpg" alt="Ghassan" style={{ position:'absolute',inset:'4px',width:'calc(100% - 8px)',height:'calc(100% - 8px)',objectFit:'cover',objectPosition:'center top',clipPath:'polygon(50% 0%,58% 3%,65% 0%,72% 5%,80% 2%,86% 8%,93% 6%,98% 12%,100% 20%,97% 28%,100% 36%,98% 44%,100% 52%,97% 60%,99% 68%,95% 75%,98% 82%,93% 88%,88% 93%,80% 97%,73% 100%,65% 97%,57% 100%,49% 97%,41% 100%,33% 97%,25% 100%,17% 96%,10% 92%,5% 85%,2% 77%,0% 68%,3% 60%,0% 52%,2% 44%,0% 36%,3% 28%,0% 20%,4% 12%,9% 6%,16% 2%,23% 5%,30% 1%,38% 4%)',zIndex:2 }} />
              </div>
            </div>
            <div>
              <h2 style={{ fontSize:'28px',fontWeight:900,color:'#fff',letterSpacing:'0.1em',marginBottom:'16px' }}>GHASSAN</h2>
              <p style={{ fontSize:'15px',color:'rgba(255,255,255,0.84)',lineHeight:1.9 }}>{ghassanDesc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ S3 — STORY ━━━ */}
      <section style={{ background:'#0a0d1a',padding:'64px 0' }}>
        <div className="section-inner">
          <h2 style={{ fontSize:'20px',fontWeight:800,color:'#f97316',textAlign:'center',marginBottom:'40px' }}>The Story Behind Ghassan Alrifai</h2>
          <div className="story-grid">
            {['/story-event.jpg','/ghassan-real.jpg'].map((img,i) => (
              <div key={i} style={{ border:'1px solid rgba(255,255,255,0.06)',borderRadius:'6px',overflow:'hidden',background:'rgba(255,255,255,0.02)' }}>
                <img src={img} alt="" style={{ width:'100%',height:'175px',objectFit:'cover' }} />
                <div style={{ padding:'16px 18px' }}>
                  <p style={{ fontSize:'12px',color:'rgba(255,255,255,0.55)',lineHeight:1.85 }}>{DUMMY.storyText}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ S4 — BUSINESS ━━━ */}
      <section style={{ background:'#06080d',padding:'64px 0' }}>
        <div className="section-inner">
          <h2 style={{ fontSize:'20px',fontWeight:900,color:'#fff',textAlign:'center',letterSpacing:'0.18em',marginBottom:'10px' }}>BUSINESS</h2>
          <p style={{ fontSize:'13px',color:'rgba(255,255,255,0.46)',textAlign:'center',lineHeight:1.85,maxWidth:'420px',margin:'0 auto 40px' }}>
            Al Mohammad Ghassan Alrifai, The Focus Is On New And Exciting Projects That Will Be Revealed Soon, Aiming To Create Solutions For The Future.
          </p>
          <div className="biz-grid">
            {businesses.map((b:any,i:number) => (
              <div key={b.id||i} style={{ borderRadius:'8px',overflow:'hidden',border:'1px solid rgba(30,60,160,0.7)',boxShadow:'0 4px 20px rgba(0,0,0,0.4)' }}>
                <div style={{ background:'#fff',display:'flex',alignItems:'center',justifyContent:'center',height:'110px',padding:'14px' }}>
                  <img src={b.image||b.logo||'/placeholder-logo.png'} alt={b.title} style={{ maxHeight:'70px',maxWidth:'85%',objectFit:'contain' }} />
                </div>
                <div style={{ background:'#0a1240',padding:'12px 14px' }}>
                  <div style={{ fontSize:'12px',fontWeight:700,color:'#fff',marginBottom:'4px' }}>{b.title}</div>
                  <div style={{ fontSize:'10px',color:'rgba(255,255,255,0.45)' }}>By</div>
                  <div style={{ fontSize:'10px',color:'rgba(255,255,255,0.45)' }}>Mr. Mohammad Ghassan A Al Rifai</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ S5 — VISION ━━━ */}
      <section style={{ background:'#07090e',padding:'56px 0' }}>
        <div className="section-inner-sm" style={{ textAlign:'center' }}>
          <h2 style={{ fontSize:'20px',fontWeight:800,color:'#f97316',marginBottom:'20px' }}>Ghassan Vision</h2>
          <p style={{ fontSize:'13.5px',color:'rgba(255,255,255,0.60)',lineHeight:2.0 }}>{visionDesc}</p>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ S6 — MISSION ━━━ */}
      <section style={{ background:'#07090e',padding:'56px 0 72px' }}>
        <div className="section-inner">
          <h2 style={{ fontSize:'20px',fontWeight:800,color:'#f97316',textAlign:'center',marginBottom:'16px' }}>Ghassan Mission</h2>
          <p style={{ fontSize:'13px',color:'rgba(255,255,255,0.53)',lineHeight:1.95,maxWidth:'700px',margin:'0 auto 44px',textAlign:'center' }}>
            {DUMMY.missionDesc}
          </p>
          <div className="mission-grid">
            {missionCards.map((c:any,i:number) => (
              <div key={c.id} style={{ background:'rgba(0,0,0,0.30)',border:'1px solid rgba(249,115,22,0.55)',borderRadius:'8px',padding:'28px 20px',display:'flex',flexDirection:'column',alignItems:'center',textAlign:'center' }}>
                <div style={{ width:'56px',height:'56px',borderRadius:'50%',background:'rgba(249,115,22,0.15)',border:'2px solid rgba(249,115,22,0.50)',display:'flex',alignItems:'center',justifyContent:'center',marginBottom:'16px',flexShrink:0 }}>
                  {ICON_MISSION[i]}
                </div>
                <h3 style={{ fontSize:'14px',fontWeight:700,color:'#fff',marginBottom:'10px' }}>{c.title}</h3>
                <p style={{ fontSize:'12px',color:'rgba(255,255,255,0.55)',lineHeight:1.8,flex:1 }}>{c.desc}</p>
                <div style={{ width:'36px',height:'36px',borderRadius:'50%',background:'#f97316',display:'flex',alignItems:'center',justifyContent:'center',marginTop:'20px',flexShrink:0 }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12,5 19,12 12,19"/></svg>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ S7 — CORE VALUES ━━━ */}
      <section className="relative overflow-hidden" style={{ background:'#252830',padding:'72px 0' }}>
        <div className="absolute inset-0" style={{ backgroundImage:'url(/arab-pattern-bg.jpg)',backgroundSize:'cover',backgroundPosition:'center',opacity:0.15,zIndex:0 }} />
        <div className="section-inner relative z-10">
          <h2 style={{ fontSize:'20px',fontWeight:900,color:'#fff',textAlign:'center',letterSpacing:'0.18em',marginBottom:'12px' }}>CORE VALUES</h2>
          <p style={{ fontSize:'13px',color:'rgba(255,255,255,0.58)',lineHeight:1.95,maxWidth:'700px',margin:'0 auto 48px',textAlign:'center' }}>
            {DUMMY.coreValuesDesc}
          </p>
          <div className="values-grid">
            {coreValues.map((v:any,i:number) => (
              <div key={v.id} style={{ background:'rgba(0,0,0,0.30)',border:'1px solid rgba(249,115,22,0.55)',borderRadius:'8px',padding:'28px 20px',textAlign:'center',position:'relative' }}>
                <div style={{ position:'absolute',top:'10px',left:'12px',fontSize:'26px',color:'rgba(249,115,22,0.35)',fontFamily:'Georgia,serif',lineHeight:1 }}>&ldquo;</div>
                <div style={{ width:'64px',height:'64px',borderRadius:'50%',background:'rgba(249,115,22,0.15)',border:'2px solid rgba(249,115,22,0.55)',display:'flex',alignItems:'center',justifyContent:'center',margin:'8px auto 16px' }}>
                  {ICON_VALUES[i%3]}
                </div>
                <div style={{ fontSize:'12px',fontWeight:800,color:'#f97316',letterSpacing:'0.14em',marginBottom:'10px' }}>{v.title}</div>
                <p style={{ fontSize:'11.5px',color:'rgba(255,255,255,0.60)',lineHeight:1.85 }}>{v.desc}</p>
                <div style={{ width:'40px',height:'2px',background:'#f97316',margin:'16px auto 0',borderRadius:'1px' }} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ S8 — BLOG ━━━ */}
      <section className="relative overflow-hidden" style={{ background:'#141720',padding:'72px 0' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage:'url(/arab-pattern-bg.jpg)',backgroundSize:'cover',opacity:0.04,zIndex:0 }} />
        <div className="absolute inset-0 pointer-events-none" style={{ background:'rgba(15,17,26,0.85)',zIndex:0 }} />
        <div className="section-inner relative z-10">
          <h2 style={{ fontSize:'20px',fontWeight:700,color:'#fff',textAlign:'center',marginBottom:'10px' }}>From His Blog</h2>
          <p style={{ fontSize:'13px',color:'rgba(255,255,255,0.46)',textAlign:'center',lineHeight:1.85,maxWidth:'500px',margin:'0 auto 40px' }}>
            Dive Into The Blog For The Latest Updates, Expert Opinions, And Detailed Information On Our Projects. Stay Updated With Content Relevant To You.
          </p>
          <div className="blog-grid">
            {blogs.map((post:any) => (
              <BlogCard key={post.id} id={String(post.id)} title={post.title} image={post.image} date={post.date||post.created_at} category={post.category||''} likes={post.likes??post.likes_count??0} comments={post.comments??post.comments_count??0} />
            ))}
          </div>
        </div>
      </section>

      <NewsletterSection />
    </>
  )
}
